import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'configuracion/horarios/';

/**
 * GET Horarios
 * @returns {Promise<Array<object>>}
 */
export const getHorarios = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Horario
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getHorario = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Horario
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postHorario = async (_values) => {
  try {
    const values = { ..._values };
    values.entrada = values.entrada.format('HH:mm:ss');
    values.salida = values.salida.format('HH:mm:ss');
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Horario
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchHorario = async (id, _values) => {
  try {
    const values = { ..._values };
    values.entrada = values.entrada.format('HH:mm:ss');
    values.salida = values.salida.format('HH:mm:ss');
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Horario
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteHorario = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
